import { BarometerChart, QuickViewReferenceValue, QuickViewWidget, useScrollIntoView } from '@procureai/ui-mui';

export const ContractAdherenceWidget = () => {
  const [widgetRef, active] = useScrollIntoView({ hash: 'contract-adherence' });
  return (
    <QuickViewWidget
      ref={widgetRef}
      active={active}
      title="Contract Adherence"
      subTitle="Value in numbers"
      value="1.07M"
      valueTooltip="1,000,000"
      referenceValue={<QuickViewReferenceValue description="Reference" value={0.5} dotColor="success" />}
      data-intercom-target="ContractAdherenceWidget"
    >
      <BarometerChart color="success" width={128} height={70} value={60} min={0} max={100} dotColor="success" />
    </QuickViewWidget>
  );
};
